const MONTH_NAMES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];
export function formatMonthYear(month, year) {
    return `${MONTH_NAMES[month - 1] ?? ''} ${year}`;
}
export function formatAmount(cents) {
    return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
    }).format(cents / 100);
}
export function formatDate(iso) {
    if (!iso)
        return '—';
    return new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(new Date(iso));
}
export function formatDateTime(iso) {
    if (!iso)
        return '—';
    return new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(iso));
}
export function formatRelativeTime(iso) {
    const diff = Date.now() - new Date(iso).getTime();
    const rtf = new Intl.RelativeTimeFormat('es', { numeric: 'auto' });
    const seconds = Math.round(diff / 1000);
    const minutes = Math.round(diff / 60_000);
    const hours = Math.round(diff / 3_600_000);
    const days = Math.round(diff / 86_400_000);
    if (seconds < 60)
        return rtf.format(-seconds, 'second');
    if (minutes < 60)
        return rtf.format(-minutes, 'minute');
    if (hours < 24)
        return rtf.format(-hours, 'hour');
    return rtf.format(-days, 'day');
}
export const MONTH_OPTIONS = MONTH_NAMES.map((name, i) => ({
    value: String(i + 1),
    label: name,
}));
/** Today's LOCAL calendar date as YYYY-MM-DD (for <input type="date"> values/limits). */
export function todayISODate() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
/** Video duration: "47 min" under an hour, "1 h 32 min" from one hour up. */
export function formatVideoDuration(totalSeconds) {
    const s = Math.max(0, Math.round(totalSeconds));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    if (h > 0)
        return m > 0 ? `${h} h ${m} min` : `${h} h`;
    if (m > 0)
        return `${m} min`;
    return `${s} s`;
}
/** Playback timestamp: "m:ss" under an hour, "h:mm:ss" from one hour up. */
export function formatPlaybackTime(totalSeconds) {
    const s = Math.max(0, Math.floor(totalSeconds));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = String(s % 60).padStart(2, '0');
    if (h > 0)
        return `${h}:${String(m).padStart(2, '0')}:${sec}`;
    return `${m}:${sec}`;
}
export function formatFileSize(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1_048_576)
        return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1_048_576).toFixed(1)} MB`;
}
//# sourceMappingURL=format.js.map